export const SETUP_LAYOUT_SET_CURRENT_OBJECT = 'SETUP_LAYOUT_SET_CURRENT_OBJECT';

/* table view */

export const SETUP_LAYOUT_SET_ALL_LAYOUTS = 'SETUP_LAYOUT_SET_ALL_LAYOUTS';
export const SETUP_LAYOUT_SET_EDIT = 'SETUP_LAYOUT_SET_EDIT';
export const SETUP_LAYOUT_ADD_LAYOUT = 'SETUP_LAYOUT_ADD_LAYOUT';

/* assignment view */

export const SETUP_LAYOUT_SET_LAYOUT_TEAM = 'SETUP_LAYOUT_SET_LAYOUT_TEAM';


// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/flow/actionType.js